module.exports = __webpack_public_path__ + "img/curved27.b4b486ef.jpeg";